import React from 'react';
import './ServicePricing.css';

const ServicePricing: React.FC = () => {
  const smallServiceItems = [
    'Kontrolu a seřízení řazení (přehazovačka a přesmykač)',
    'Kontrolu a seřízení brzd',
    'Kontrolu středového složení',
    'Dotažení klik',
    'Kontrolu a dotažení pedálů',
    'Kontrolu a dotažení namáhaných spojů',
    'Kontrolu a dotažení hlavového složení (řízení)',
    'Změření opotřebení řetězu a jeho promazání',
    'Centrování předního a zadního kola',
    'Kontrolu plášťů a jejich dohuštění na správný tlak'
  ];

  const largeServiceItems = [
    'Kontrolu a seřízení řazení (přehazovačka a přesmykač)',
    'Kontrolu a seřízení brzd',
    'Kontrolu středového složení',
    'Dotažení klik',
    'Kontrolu a dotažení pedálů',
    'Kontrolu a dotažení namáhaných spojů',
    'Kontrolu a dotažení hlavového složení (řízení)',
    'Promazání tahů (bovdenů)',
    'Změření opotřebení řetězu a jeho promazání',
    'Centrování předního a zadního kola',
    'Kontrolu plášťů a jejich dohuštění na správný tlak'
  ];

  const largeServiceExtra = [
    'Dotažení konusů a vícekolečka (kazety)',
    'Dotažení převodníků a klik',
    'Kontrola, nastavení a dotažení řídítek',
    'Kontrola, nastavení a dotažení sedla',
    'Demontáž, vyčištění a promazání osiček a nábojů kol, hlavového složení a středového složení',
    'Výměna bowdenů a koncovek',
    'Výměna lanek nebo výměna brzdové kapaliny',
    'Celkové umytí kola'
  ];

  const largeFullSuspensionExtra = [
    ...largeServiceExtra,
    'Nastavení vidlice a tlumiče podle váhy jezdce',
    'Kontrola ložisek zadní stavby',
    'Promazání čepů a kontrola dotažení momentovým klíčem',
    'Repas vidlice a tlumiče (vyčištění a promazání - malý servis)'
  ];

  return (
    <section className="service-pricing" id="service-pricing">
      <div className="service-pricing-title-container">
        <h2 className="section-title">Servis</h2>
      </div>
      <div className="service-pricing-container">
        <div className="service-packages-grid">
          <div className="service-package">
            <div className="service-package-header">
              <h4>Malý servis<br />všech kol</h4>
            </div>
            <div className="service-price" style={{ textAlign: 'right', marginBottom: '20px' }}>800 Kč</div>
            <ul className="service-list">
              {smallServiceItems.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </div>

          <div className="service-package featured">
            <div className="service-package-header">
              <h4>Velký servis <br /> pevné kolo</h4>
            </div>
            <div className="service-price" style={{ textAlign: 'right', marginBottom: '20px' }}>1.800 Kč</div>
            <ul className="service-list">
              {largeServiceItems.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
            <div className="service-extra">
              <h5>Obsahuje navíc:</h5>
              <ul className="service-list">
                {largeServiceExtra.map((item, index) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>
            </div>
          </div>

          <div className="service-package">
            <div className="service-package-header">
              <h4>Velký servis <br />celoodpružené</h4>
            </div>
            <div className="service-price" style={{ textAlign: 'right', marginBottom: '20px' }}>4.500 Kč</div>
            <ul className="service-list">
              {largeServiceItems.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
            <div className="service-extra">
              <h5>Obsahuje navíc:</h5>
              <ul className="service-list">
                {largeFullSuspensionExtra.map((item, index) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>
            </div>
          </div>
        </div>
        <p className="service-pricing-disclaimer" role="note">
          Uvedené ceny zahrnují práci servisu. Náhradní díly a spotřební materiál v ceně nejsou —
          účtují se zvlášť podle skutečně použitého zboží a provedených úkonů.
        </p>
      </div>
    </section>
  );
};

export default ServicePricing;

